import { createAction } from 'redux-actions';

export const registerSalesLeadAction = createAction('REQUEST/REGISTER_SALES_LEAD');
export const fetchSalesLeadAction = createAction('REQUEST/FETCH_SALES_LEAD');
export const fetchSalesLeadSignUpUsersAction = createAction(
  'REQUEST/FETCH_SALES_LEAD_SIGNUP_USERS',
);
